import React from 'react';
import {FormGroup, Intent} from '@blueprintjs/core';

import {SimpleSelect} from '../../select';

interface SelectOptionProps {
  label: string;
  selectLabel?: string;
  selected: any;
  options: any;
  onChange: (value: any) => void;
  disabled?: boolean;
}

export const SelectOption = ({
  label,
  selectLabel,
  selected,
  options,
  onChange,
  disabled = false,
}: SelectOptionProps) => {
  return (
    <FormGroup label={label} inline={true} className="select-option">
      <SimpleSelect
        disabled={disabled || options.length === 0}
        selected={selected}
        options={options}
        onChange={onChange}
        buttonProps={{
          minimal: true,
          small: true,
          outlined: true,
          intent: !selected ? Intent.DANGER : undefined,
        }}
        popoverProps={{
          usePortal: true
        }}
        label={selectLabel}
        selectDefault={false}
      />
    </FormGroup>
  )
};

export default SelectOption;
